var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item"},[_vm._m(0),_c('div',{staticClass:"list-item-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-wrap"},[_c('div',{staticClass:"tag"},[_vm._v("docx")])])
}]

export { render, staticRenderFns }